function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { GetItContext } from "../../base/provider/GetItContext";
import { NodesUtil } from "../NodesUtil";
import isBlank from "@sedan-utils/is-blank";
import { Tooltip, Upload } from "antd";
import { BrainClient } from "imagica-corekit/dist/base/api/BrainClient";
import { JsonUtil } from "imagica-corekit/dist/base/cutil/JsonUtil";
import { tryPromise } from "imagica-corekit/dist/base/cutil/LangUtil";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { Analytics } from "imagica-corekit/dist/base/port/Analytics";
import { StudioProjectV3UploadImgValue } from "imagica-corekit/dist/base/project/domain/StudioProjectAttributesV3NodeData";
import { AuthStore } from "imagica-corekit/dist/base/store/AuthStore";
import { MeStore } from "imagica-corekit/dist/base/store/MeStore";
import { WebsocketService } from "imagica-corekit/dist/base/storyV2/service/WebsocketService";
import { get, some } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import styles from "./DragDropFile.module.scss";
import { UploadLoading } from "./UploadLoading";
import { fileFormatConfig } from "./fileFormatConfig";
var Dragger = Upload.Dragger;
export function UploadFile(props) {
  var getIt = useContext(GetItContext);
  var analytics = getIt(Analytics);
  var socketService = getIt(WebsocketService);
  var meStore = getIt(MeStore);
  var authStore = getIt(AuthStore);
  var brainClient = getIt(BrainClient);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMsg = _useState4[0],
    setErrorMsg = _useState4[1];
  var _useState5 = useState({
      loaded: 0,
      total: 0
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    percent = _useState6[0],
    setPercent = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    unStructuredDownloadFailedText = _useState10[0],
    setUnStructuredDownloadFailedText = _useState10[1];
  var handleAmpEvent = function handleAmpEvent(name) {
    if (isBlank(name)) {
      return;
    }
    var regex = /(.*)\.([^.]+)$/;
    var match = regex.exec(name);
    if (match) {
      analytics.logEvent("upload_file", {
        name: match[1],
        extension: match[2]
      });
    }
  };
  var beforeUpload = function beforeUpload(file) {
    setFile(file);
    handleAmpEvent(file.name);
    return true;
  };
  var removeFile = function removeFile() {
    setFile(undefined);
    setPercent({
      loaded: 0,
      total: 0
    });
    setErrorMsg("");
    setLoading("");
    // TODO need to abort the upload file
  };
  var getDisplayTypeByFileFormat = function getDisplayTypeByFileFormat(filename) {
    // TODO need to get file format from gpt api
    var _ref = /(?:\.([^.]+))?$/.exec(filename) || [],
      _ref2 = _slicedToArray(_ref, 2),
      fileFormat = _ref2[1];
    if (fileFormat) {
      var uploadType = Object.entries(fileFormatConfig).find(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          formats = _ref4[1].formats;
        return some(formats, function (format) {
          return format.toLowerCase() === fileFormat.toLowerCase();
        });
      });
      if (uploadType) {
        var _ref5 = uploadType,
          _ref6 = _slicedToArray(_ref5, 2),
          displayType = _ref6[0],
          featureTag = _ref6[1].featureTag;
        if (featureTag && props.featureTags[featureTag] === false || featureTag === undefined) {
          return {
            displayType: displayType,
            format: fileFormat
          };
        }
      }
    }
    if (props.featureTags["disableUploadNodeUnStructured"] === true) {
      return {
        displayType: "uploadFile",
        format: fileFormat
      };
    }
    return {
      displayType: "unStructured",
      format: fileFormat
    };
  };
  var uploadS3 = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var formData, _getDisplayTypeByFile, displayType, format, res, s3Url, uuid, needToCreateBlobUrl, _loading, _errorMsg, _unStructuredDownloadFailedText, _displayType, _res, _res2, _res3, _me$id, me, id, pubsub_topic, socketPromise, indexerPromise, result, defaultError, _defaultError, _res5, _props$asInputNodeCha, textAreaValue;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!file) {
              _context2.next = 66;
              break;
            }
            formData = new FormData();
            formData.append("file", file, file.name);
            _getDisplayTypeByFile = getDisplayTypeByFileFormat(file.name), displayType = _getDisplayTypeByFile.displayType, format = _getDisplayTypeByFile.format;
            uuid = undefined, needToCreateBlobUrl = "", _loading = "", _errorMsg = "", _unStructuredDownloadFailedText = "", _displayType = displayType;
            _context2.prev = 5;
            if (!(file.size > 50 * 1024 * 1000)) {
              _context2.next = 8;
              break;
            }
            throw "We accept the following files, under 50 Mb size";
          case 8:
            _loading = "pending";
            _context2.next = 11;
            return brainClient.openAi.uploadStudios(formData, {
              onprogress: function onprogress(p) {
                setPercent(p);
              }
            });
          case 11:
            res = _context2.sent;
            _loading = "finish";
            if (res.data) {
              _context2.next = 15;
              break;
            }
            throw "Failed to get s3 path";
          case 15:
            //上传完成继续cot流程
            props.handleCot();
            s3Url = ((_res = res) === null || _res === void 0 || (_res = _res.data) === null || _res === void 0 ? void 0 : _res.object_s3_url) || ((_res2 = res) === null || _res2 === void 0 || (_res2 = _res2.data) === null || _res2 === void 0 ? void 0 : _res2.s3_https_url) || "";
            uuid = (_res3 = res) === null || _res3 === void 0 || (_res3 = _res3.data) === null || _res3 === void 0 ? void 0 : _res3.uuid;
            needToCreateBlobUrl = "/api/me/upload/studios?url=".concat(encodeURIComponent(s3Url));
            // 整理这块代码时存在疑问
            // 总结如下：(仅供参考)上传不支持类型文件且有unstructured 的feature tag 或者没有unstructured 的feature tag 进来下面的处理
            if (!(_displayType === "unStructured" || _displayType === "uploadFile")) {
              _context2.next = 50;
              break;
            }
            _context2.prev = 20;
            _loading = "pending";
            setLoading(_loading);
            _context2.next = 25;
            return meStore.get();
          case 25:
            me = _context2.sent;
            id = (_me$id = me.id) !== null && _me$id !== void 0 ? _me$id : authStore.state.guestToken;
            pubsub_topic = "/studios/".concat(id, "/uploadFile/").concat(Date.now()).concat(props.id);
            socketPromise = new Promise(function (resolve, reject) {
              var listener = function listener(res, err) {
                if (res !== null && res !== void 0 && res.metadata) {
                  return resolve({
                    data: {
                      data: res.metadata
                    }
                  });
                }
                if (err) {
                  return reject(err);
                }
              };
              socketService.on(pubsub_topic, undefined, listener);
            });
            indexerPromise = new Promise( /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
                var _res4, _indexResult$data, _indexResult$data2;
                var indexResult;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return tryPromise(brainClient.openAi.indexers({
                        data: {
                          file: (_res4 = res) === null || _res4 === void 0 || (_res4 = _res4.data) === null || _res4 === void 0 ? void 0 : _res4.object_key,
                          loader: "PDFReader",
                          query: "describe the file in less than 6 words"
                        },
                        pubsub_topic: pubsub_topic,
                        uuid: uuid
                      }));
                    case 2:
                      indexResult = _context.sent;
                      if (indexResult.data && ((_indexResult$data = indexResult.data) === null || _indexResult$data === void 0 ? void 0 : _indexResult$data.status) === 200 || ((_indexResult$data2 = indexResult.data) === null || _indexResult$data2 === void 0 ? void 0 : _indexResult$data2.status) === 201) {
                        resolve(indexResult.data.data);
                      }
                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x, _x2) {
                return _ref8.apply(this, arguments);
              };
            }());
            _context2.next = 32;
            return Promise.race([socketPromise, indexerPromise]);
          case 32:
            result = _context2.sent;
            needToCreateBlobUrl = "/api/me/upload/studios?url=".concat(encodeURIComponent(get(result, "data.data.unstructured_path")));
            _unStructuredDownloadFailedText = get(result, "data.data.response");
            setUnStructuredDownloadFailedText(_unStructuredDownloadFailedText);
            _context2.next = 46;
            break;
          case 38:
            _context2.prev = 38;
            _context2.t0 = _context2["catch"](20);
            _displayType = "uploadFile";
            // const defaultError = "Unable to generate summary.";
            _unStructuredDownloadFailedText = "";
            setUnStructuredDownloadFailedText(_unStructuredDownloadFailedText);
            defaultError = "This document is not supported, please delete and upload another file.";
            _errorMsg = typeof _context2.t0 === "string" ? _context2.t0 : defaultError;
            setErrorMsg(_errorMsg);
          case 46:
            _context2.prev = 46;
            _loading = "finish";
            setLoading(_loading);
            return _context2.finish(46);
          case 50:
            _context2.next = 59;
            break;
          case 52:
            _context2.prev = 52;
            _context2.t1 = _context2["catch"](5);
            _defaultError = "Upload failed";
            _displayType = "uploadFile";
            _errorMsg = typeof _context2.t1 === "string" ? _context2.t1 : _defaultError;
            setErrorMsg(_errorMsg);
            setLoading(_loading);
          case 59:
            _context2.prev = 59;
            setLoading(_loading);
            textAreaValue = JsonUtil.toModelFromInstance(new StudioProjectV3UploadImgValue(), {
              value: s3Url,
              s3Url: s3Url,
              file: {
                name: file.name,
                size: file.size
              },
              loading: _loading,
              errorMsg: _errorMsg,
              percent: percent,
              name: file.name,
              size: file.size,
              s3Path: (_res5 = res) === null || _res5 === void 0 || (_res5 = _res5.data) === null || _res5 === void 0 ? void 0 : _res5.object_key,
              needToCreateBlobUrl: needToCreateBlobUrl,
              unStructuredDownloadFailedText: _unStructuredDownloadFailedText,
              format: format,
              uuid: uuid
            });
            console.log("🚀 ~ uploadS3 ~ textAreaValue:", textAreaValue);
            props.onChangeData(_objectSpread(_objectSpread({}, _displayType === "unStructured" ? {} : {
              initCreateBlobUrl: {
                objectURL: URL.createObjectURL(file),
                fileBlob: file,
                loading: false
              }
            }), {}, {
              displayType: _displayType,
              isLimitExceeded: false,
              textAreaValue: textAreaValue,
              autoRunEdge: props === null || props === void 0 ? void 0 : props.chatAi
            }));
            props === null || props === void 0 || (_props$asInputNodeCha = props.asInputNodeChange) === null || _props$asInputNodeCha === void 0 || _props$asInputNodeCha.call(props, textAreaValue);
            return _context2.finish(59);
          case 66:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[5, 52, 59, 66], [20, 38, 46, 50]]);
    }));
    return function uploadS3() {
      return _ref7.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (!NodesUtil.isEmpty(file) && file instanceof File) {
      uploadS3();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);
  useEffect(function () {
    var textAreaValue = props.textAreaValue;
    if (!NodesUtil.isEmpty(textAreaValue)) {
      setFile(textAreaValue.file);
      setErrorMsg(textAreaValue.errorMsg);
      setPercent(textAreaValue.percent);
      setLoading(textAreaValue.loading);
      setUnStructuredDownloadFailedText(textAreaValue.unStructuredDownloadFailedText);
    }
  }, [props.textAreaValue]);
  useEffect(function () {
    if (props.dropUploadFileData && NodesUtil.isEmpty(props.textAreaValue) && props.isInCanvas === true) {
      var dropUploadFileData = props.dropUploadFileData;
      var fileData = dropUploadFileData.fileData;
      var fileUrl = dropUploadFileData.url;
      var filename = dropUploadFileData.filename || "";
      if (fileUrl) {
        fetch(fileUrl).then(function (response) {
          return response.blob();
        }).then(function (res) {
          setFile(new File([res], filename));
        });
      }
      if (fileData) {
        setFile(fileData);
        handleAmpEvent(fileData.name);
      }
    }
  }, [props.dropUploadFileData]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.sourceBox
  }, file === undefined && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.desc
  }, "Upload files from your computer."), /*#__PURE__*/React.createElement(SourceTooltip, {
    title: /*#__PURE__*/React.createElement(SupportFile, null),
    isPopupContainer: (props === null || props === void 0 ? void 0 : props.canvasType) !== "canvas"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.SupportFormat
  }, "Supported file formats"))), /*#__PURE__*/React.createElement("div", {
    className: styles.uploadWrapper
  }, /*#__PURE__*/React.createElement(Dragger, {
    name: "file",
    className: styles.dragger,
    multiple: false,
    onRemove: removeFile,
    customRequest: function customRequest() {},
    beforeUpload: beforeUpload
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.upload
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "upload.svg")
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.desc
  }, "Drag and drop your files here to upload them."), /*#__PURE__*/React.createElement("div", {
    className: styles.limitSize
  }, "50 Mb max file size."))))), file && /*#__PURE__*/React.createElement(UploadLoading, {
    fileName: file.name,
    onClose: removeFile,
    percent: percent,
    size: file.size,
    errorMsg: errorMsg,
    unStructuredDownloadFailedText: unStructuredDownloadFailedText,
    loading: loading,
    isInCanvas: props.isInCanvas,
    isStaticApp: props.isStaticApp
  }));
}
function SupportFile() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.surportWrapper
  }, NodesUtil.constants.supportList.map(function (s) {
    return /*#__PURE__*/React.createElement("span", {
      key: s,
      className: styles.surportItem
    }, s);
  }));
}
function SourceTooltip(_ref9) {
  var children = _ref9.children,
    title = _ref9.title,
    isPopupContainer = _ref9.isPopupContainer;
  if (isPopupContainer) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      placement: "top",
      title: title,
      getPopupContainer: function getPopupContainer() {
        return document.getElementById("AiSaasHeader");
      },
      overlayInnerStyle: {
        borderRadius: "10px",
        backgroundColor: "rgba(0, 0, 3, 0.85)",
        padding: "20px 30px"
      }
    }, children);
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: title,
    overlayInnerStyle: {
      borderRadius: "10px",
      backgroundColor: "rgba(0, 0, 3, 0.85)",
      padding: "20px 30px"
    }
  }, children);
}